import React from "react"
import { Link, StaticQuery, graphql } from "gatsby"
import "./style.css"
import Img from 'gatsby-image';
import Sectional from "./Sectional/Sectional"

import * as styles from "./layout.module.css"
import SocialIcons from "./Sectional/SocialIcons/SocialIcons"
import config from "../config"

const Layout: React.FC = ({
  children,
  client,
}) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          season1: file(
            sourceInstanceName: { eq: "images" }
            relativePath: { eq: "season1-logo-horizontal.png" }
          ) {
            childImageSharp {
              fixed(height: 30, grayscale: false) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          ewb: file(
            sourceInstanceName: { eq: "images" }
            relativePath: { eq: "ewb-logo-horizontal.png" }
          ) {
            childImageSharp {
              fixed(height: 60, grayscale: false) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      `}
      render={({
        season1,
        ewb,
      }) => (
      <div className={styles.Root}>
        <Sectional
          className={styles.navbar}
          innerStyle={{ padding: 0 }}
        >
          <div className={styles.navbarContent} style={{
              lineHeight: (client === 'ewb' ? 65 : 30) + 'px'
            }}>
            {
              client &&
              <Link className={styles.logo} to="/" style={{
                marginTop: client === 'season1' ? 7 : 0,
              }}>
                {/* <img src={require(`../images/${config[client].logoSrcName}`)} style={{height: 30}} /> */}
                <Img title="Logo" fixed={
                  client == 'ewb' ?
                  ewb.childImageSharp.fixed :
                  season1.childImageSharp.fixed
                } />
              </Link>
            }
            <span className={styles.socialLinks}>
              <span className={styles.socialIcons} style={{
                marginTop: client === 'season1' ? 7 : 15,
                display: 'inline-block',
              }}>
                <SocialIcons client={client} />
              </span>
            </span>
          </div>
        </Sectional>
        <main className={styles.Main}>{children}</main>
      </div>
      )}
    />
  )
}

export default Layout
